import { TaskAttachedFileModel } from "./TaskAttachedFileModel";
import { TaskPersonModel } from "./TaskPersonModel";
import { TaskQueueModel } from "./TaskQueueModel";
import { TaskParameterModel } from "@/components";
import { NamespaceModel } from "./NamespaceModel";
import { ProjectModel } from "@/models";
import DifficultyLevelTaskModel from "@/api/Main/dataSource/api/projects/task/i-service/models/task/response/DifficultyLevelTaskModel";
import { TaskImportServiceEnum } from "@/enums";
import ZmkTypePerformer from "@/pages/tasks-order-pages/enums/ZmkTypePerformer";

/**
 * * Модель, описывающая задачу
 */
export class TaskModel {
  /**Идентификатор задачи */
  Id!: number;
  /**id проекта */
  ProjectId: number;
  /**Проект */
  Project?: ProjectModel;
  /**Автор */
  Author?: TaskPersonModel;
  /**Название задачи */
  Name!: string;
  /**Статус */
  Status?: TaskParameterModel;
  /**Приоретет */
  Priority?: TaskParameterModel;
  /**Исполнители */
  Performers: TaskPersonModel[] = [];
  /**Наблюдатели */
  Observers: TaskPersonModel[] = [];
  /**Тэги к задаче */
  Tags: TaskParameterModel[] = [];
  /**Количество вложенных задач */
  Subtasks: TaskModel[] = [];
  /** абсолютная позиция по счету */
  Number?: number = 0;
  /**Прикрепленные файлы */
  AttachedFiles: TaskAttachedFileModel[] = [];
  /**Дата создания */
  DateCreate?: Date;
  /**Дедлайн */
  Deadline?: Date;
  /**Тип */
  Type?: TaskParameterModel;
  /**Id родительской задачи */
  ParentTaskId?: number;
  /**Происходит загрузка подзадач */
  IsLoadingSubtasks: boolean = false;
  /**Список очередей, в которых находится задача */
  Queues: TaskQueueModel[] = [];
  /**Сложность задачи */
  Difficulty?: DifficultyLevelTaskModel;
  /**Количество подзадач из текущей очереди */
  CurrentQueueSubtaskCount: number = 0;
  /**Количество подзадач из других очередей */
  OtherQueueSubtaskCount: number = 0;
  /**Информация неймспейса */
  NamespaceInfo: NamespaceModel[] = [];
  /**Оценка времени */
  EstimateTime: number;
  /**затраченное  время */
  WorkTime: number;
  /**Подсвечен */
  IsHighlighted?: boolean;
  /**Добавлено в очередность не овнером */
  isAddedQueueByNotOwner?: boolean = false;
  /**Сервис импорта задачи, если задача была импортирована */
  ImportService?: TaskImportServiceEnum;
  /**Тип змк */
  ZmkType?: ZmkTypePerformer;
  /**Родительская задача */
  Parent?: TaskModel;
  /**Очереди в задаче */
  QueueToTaskRelationList?: TaskQueueModel[] = []

  /**Общее количество подзадач */
  get SubtasksCount() {
    return this.CurrentQueueSubtaskCount + this.OtherQueueSubtaskCount;
  }
  /**Форматированный срок завершения задачи */
  get FormattedDeadline() {
    return this.Deadline ? this.FormatDate(this.Deadline) : "";
  }
  /**Форматированный срок создания задачи */
  get FormattedDateCreate() {
    return this.DateCreate ? this.FormatDate(this.DateCreate) : "";
  }

  /**Задача находится в текущей очереди */
  CheckIsCurrentQueue(queueId: string) {
    return this.Queues.some((q) => q.Id == queueId);
  }
  /**Форматирование даты */
  FormatDate(date: Date) {
    return `${this.FormatNumber(date.getDate())}.${this.FormatNumber(
      date.getMonth(),
    )}.${date.getFullYear()} в ${this.FormatNumber(date.getHours())}:${this.FormatNumber(
      date.getMinutes(),
    )}`;
  }
  /**Форматирования числа */
  FormatNumber(num: number) {
    return num.toString().length === 2 ? num.toString() : `0${num}`;
  }

  constructor(obj?: Partial<TaskModel>) {
    Object.assign(this, obj);
  }
}
